import { render } from "./img-title.vue?vue&type=template&id=09c3a1bc&scoped=true&ts=true"
import script from "./img-title.vue?vue&type=script&lang=ts"
export * from "./img-title.vue?vue&type=script&lang=ts"

import "./img-title.vue?vue&type=style&index=0&id=09c3a1bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c3a1bc"]])

export default __exports__